<qaroni-wrapper><router-outlet /></qaroni-wrapper>
